/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

export const languagesWithImpressum = [MarketLanguage.DE];
